import { createAsyncThunk } from "@reduxjs/toolkit";
import { getNotificationLog } from "src/api/sp";

export const fetchNotificationLog = createAsyncThunk(
  "notificationLog/fetchNotificationLog",
  (payload: {
    storeId: string;
    startDate: string;
    endDate: string;
    type: string[];
    status: string[];
  }) => getNotificationLog(payload)
);
